import HttpClient, { httpDefaultConfig } from './config/http/HttpClient'
import {
  authorizationRequestInterceptor,
  authorizationResponseSuccessInterceptor,
  authorizationResponseErrorInterceptor,
} from './config/interceptors/authorization/authorization.interceptor'
import { errorInterceptor } from './config/interceptors/error/error.interceptor'
import LoadingInterceptor from './config/interceptors/loading/loading.interceptor'
import { internalURLRequestInterceptor } from './config/interceptors/url/url.interceptor'

const DEVELOP_API_URL = 'https://api-sites-loja.develop.juntossomosmaisi.com.br'
const STAGING_API_URL = 'https://api-sites-loja.homolog.juntossomosmaisi.com.br'
const PRODUCTION_API_URL = 'https://api-sites-loja.juntossomosmais.com.br'

const SITES_API_URLS = {
  development: DEVELOP_API_URL,
  local: DEVELOP_API_URL,
  staging: STAGING_API_URL,
  production: PRODUCTION_API_URL,
}

const createInternalApi = (baseURL) => {
  const internalAPI = new HttpClient({
    baseURL: baseURL,
    withCredentials: true,
  })

  internalAPI.addRequestInterceptor(authorizationRequestInterceptor)
  internalAPI.addResponseInterceptor(
    authorizationResponseSuccessInterceptor,
    authorizationResponseErrorInterceptor
  )
  internalAPI.addRequestInterceptor(LoadingInterceptor.request)
  internalAPI.addResponseInterceptor(
    LoadingInterceptor.response,
    LoadingInterceptor.error
  )
  internalAPI.addErrorInterceptor(errorInterceptor)
  internalAPI.addRequestInterceptor(internalURLRequestInterceptor)
  return internalAPI
}

export const sitesApi = createInternalApi(
  SITES_API_URLS[process.env.VUE_APP_ENV]
)

export const external = new HttpClient(
  { ...httpDefaultConfig, allowAbsoluteUrls: true },
  true
)
